import { Report } from "../Interfaces/TableInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import {
  DeltaHedgeMode,
  IDecrementalTableReport,
  IDeltaClosureTableReport,
  IDeltaHedgeTablesSearchParam,
  IIncrementalTableReport,
  IOptionOptimizationTableReport,
  ISizeDecreaseTableReport,
  ISizeIncreaseTableReport,
} from "../Interfaces/deltaHedgeSettings";
import {
  getRequest,
  getTable,
  patchRequest,
  postRequest,
  putRequest,
} from "./requestTemplates";

// export const getSizeIncreaseTable = (
//   searchParam: ISizeIncreaseSearchParams,
//   offset: number | null,
//   pageSize: number | null,
//   sortingType?: string
// ): Promise<Report<ISizeIncreaseTableReport>> =>
//   getTable<ISizeIncreaseSearchParams, ISizeIncreaseTableReport>(
//     "/v1/deltaHedgeSetting/ReleaseCals",
//     searchParam,
//     offset,
//     pageSize,
//     sortingType
//   );

// export const getSizeDecreaseTable = (
//   searchParam: ISizeDecreaseSearchParams,
//   offset: number | null,
//   pageSize: number | null,
//   sortingType?: string
// ): Promise<Report<ISizeDecreaseTableReport>> =>
//   getTable<ISizeDecreaseSearchParams, ISizeDecreaseTableReport>(
//     "/v1/deltaHedgeSetting/ReleaseCals",
//     searchParam,
//     offset,
//     pageSize,
//     sortingType
//   );

// export const getDeltaClosureTable = (
//   searchParam: IDeltaClosureSearchParams,
//   offset: number | null,
//   pageSize: number | null,
//   sortingType?: string
// ): Promise<Report<IDeltaClosureTableReport>> =>
//   getTable<IDeltaClosureSearchParams, IDeltaClosureTableReport>(
//     "/v1/deltaHedgeSetting/ReleaseCals",
//     searchParam,
//     offset,
//     pageSize,
//     sortingType
//   );

export const getDecrementalTable = (
  searchParam: IDeltaHedgeTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IDecrementalTableReport>> =>
  getTable<IDeltaHedgeTablesSearchParam, IDecrementalTableReport>(
    "/v1/deltaHedgeSetting/getDecrementalTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getIncrementalTable = (
  searchParam: IDeltaHedgeTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IIncrementalTableReport>> =>
  getTable<IDeltaHedgeTablesSearchParam, IIncrementalTableReport>(
    "/v1/deltaHedgeSetting/getIncrementalTable",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

// export const getOptionOptimizationTable = (
//   searchParam: IOptionOptimizationSearchParams,
//   offset: number | null,
//   pageSize: number | null,
//   sortingType?: string
// ): Promise<Report<IOptionOptimizationTableReport>> =>
//   getTable<IOptionOptimizationSearchParams, IOptionOptimizationTableReport>(
//     "/v1/deltaHedgeSetting/ReleaseCals",
//     searchParam,
//     offset,
//     pageSize,
//     sortingType
//   );

export const getIncrementalMode = (): Promise<DeltaHedgeMode> =>
  getRequest("/v1/deltaHedgeSetting/getIncrementalMode");

export const setIncrementalMode = (
  mode: DeltaHedgeMode
): Promise<Packet<boolean>> =>
  postRequest("/v1/deltaHedgeSetting/setIncrementalMode", { mode });

export const getDecrementalMode = (): Promise<DeltaHedgeMode> =>
  getRequest("/v1/deltaHedgeSetting/getDecrementalMode");

export const setDecrementalMode = (
  mode: DeltaHedgeMode
): Promise<Packet<boolean>> =>
  postRequest("/v1/deltaHedgeSetting/setDecrementalMode", { mode });

export const addIncrement = (
  formValues: IIncrementalTableReport
): Promise<Packet<boolean>> =>
  postRequest("/v1/deltaHedgeSetting/AddIncremental", formValues);

export const editIncrement = (
  formValues: IIncrementalTableReport
): Promise<Packet<boolean>> =>
  putRequest("/v1/deltaHedgeSetting/EditIncremental", formValues);

export const addDecrement = (
  formValues: IDecrementalTableReport
): Promise<Packet<boolean>> =>
  postRequest("/v1/deltaHedgeSetting/AddDecremental", formValues);

export const editDecrement = (
  formValues: IDecrementalTableReport
): Promise<Packet<boolean>> =>
  putRequest("/v1/deltaHedgeSetting/EditDecremental", formValues);
